import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Insurance.css";

const COVERED_ITEMS = [
  { emoji: "📱", name: "iPhone 15 Pro", price: "$1,199", coveredUntil: "Apr 2", daysLeft: 18, status: "Active", statusClass: "active" },
  { emoji: "💻", name: "MacBook Air M3", price: "$1,299", coveredUntil: "Mar 28", daysLeft: 13, status: "Active", statusClass: "active" },
  { emoji: "🎧", name: "AirPods Max", price: "$549", coveredUntil: "Mar 15", daysLeft: null, status: "Expiring", statusClass: "expiring" },
  { emoji: "⌚", name: "Apple Watch Ultra", price: "$799", coveredUntil: "Feb 20", daysLeft: null, status: "Expired", statusClass: "expired" },
  { emoji: "🖥️", name: "LG Monitor", price: "$649", coveredUntil: "May 1", daysLeft: 47, status: "Active", statusClass: "active" },
];

const OPEN_CLAIMS = [
  { item: "AirPods Max — Screen crack", amount: "$450", filed: "Feb 28", status: "In Review", expected: "Mar 10–20" },
];

export default function Insurance() {
  const [claimsOpen, setClaimsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="insurance-page">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="ins-hero">
        <h1 className="ins-title">Purchase Protection</h1>
        <p className="ins-subtitle">Every purchase is covered automatically. No signup needed.</p>
      </section>

      <div className="ins-stats-row">
        <div className="ins-stat">
          <span className="ins-stat-value">23</span>
          <span className="ins-stat-label">Covered</span>
        </div>
        <div className="ins-stat">
          <span className="ins-stat-value">90</span>
          <span className="ins-stat-label">Days</span>
        </div>
        <div className="ins-stat">
          <span className="ins-stat-value">$10K</span>
          <span className="ins-stat-label">Per claim</span>
        </div>
      </div>

      <div className="ins-progress">
        <div className="ins-progress-label">
          <span>Claimed $450</span>
          <span>$50,000 annual limit</span>
        </div>
        <div className="ins-progress-bar">
          <div className="ins-progress-fill" style={{ width: "0.9%" }} />
        </div>
      </div>

      {/* Covered items */}
      <section className="ins-covered">
        <h3 className="ins-covered-title">Covered Items</h3>
        {COVERED_ITEMS.map((item, i) => (
          <div key={i} className="ins-item">
            <div className="ins-item-left">
              <span className="ins-item-name">{item.name}</span>
              <span className="ins-item-meta">{item.price} · Until {item.coveredUntil}</span>
            </div>
            <span className={`ins-item-status ${item.statusClass}`}>{item.status}</span>
          </div>
        ))}
      </section>

      {/* Claims card */}
      <button
        className={`ins-claims-card ${claimsOpen ? "open" : ""}`}
        onClick={() => setClaimsOpen(!claimsOpen)}
        type="button"
      >
        <div className="ins-claims-summary">
          <span className="ins-claims-title">Claims</span>
          <span className="ins-claims-count">{OPEN_CLAIMS.length} open</span>
        </div>
        <span className={`ins-claims-chevron ${claimsOpen ? "open" : ""}`}>›</span>
      </button>

      {claimsOpen && (
        <div className="ins-claims-body">
          {OPEN_CLAIMS.map((c, i) => (
            <div key={i} className="ins-claim-item">
              <div className="ins-claim-info">
                <span className="ins-claim-name">{c.item}</span>
                <span className="ins-claim-meta">{c.amount} · Filed {c.filed} · {c.expected}</span>
              </div>
              <span className="ins-claim-status">{c.status}</span>
            </div>
          ))}
          <button
            className="ins-claim-cta"
            type="button"
            onClick={(e) => { e.stopPropagation(); navigate("/insurance/claim"); }}
          >
            File New Claim →
          </button>
        </div>
      )}

      <div className="ins-tip">Always keep your receipt — makes claims faster</div>

      <div className="ins-close-wrap">
        <Link to="/benefits" className="ins-close-btn">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
